export const Alert = ({ desc }: { desc: string }) => {
  return (
    <div className="border border-solid border-x_alert rounded-3xl text-x_alert_light text-xs py-0.5 px-2">
      ⚠️ {desc}
    </div>
  );
};
